import React from 'react';
import { Badge, Button, Card, Col, Row, Typography, Space, Tabs } from 'antd';
import { TagOutlined } from '@ant-design/icons';
const { Text, Title } = Typography;
const { TabPane } = Tabs;

const cardStyles = {
  borderRadius: 24,
  textAlign: 'center',
  padding: '24px 16px',
  minHeight: 180,
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', // Soft shadow for cards
  transition: 'transform 0.3s ease, box-shadow 0.3s ease', // Smooth hover effect
};

const imgStyles = {
  height: 50,
  objectFit: 'contain',
  marginBottom: 12,
  transition: 'transform 0.3s ease', // Smooth image hover effect
};

const CardList = ({ offerList, setIsExpanded, isExpanded }) => {
    console.log("offerList",offerList);
    
  const taggedOffers = offerList.filter(item => item.show_tag);
  const untaggedOffers = offerList.filter(item => !item.show_tag);

  const renderCard = (item) => {
    const cardContent = (
      <Card
        bordered
        hoverable
        style={cardStyles}
        styles={{ body: { padding: 0 } }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
      >
        <img src={item.image} alt={item.title} style={imgStyles} />
        <Title level={5} style={{ marginBottom: 4, fontWeight: 600 }}>
          {item.title}
        </Title>
        <Text strong style={{ fontSize: 16, color: '#1890ff' }}>
          -₹{parseInt(item.amount, 10).toLocaleString()}
        </Text>
      </Card>
    );

    return (
      <Col key={item.id || item.title} style={{ minWidth: 160, maxWidth: '100%' }}>
        {item.show_tag ? (
          <Badge.Ribbon
            text={item.tag_text}
            placement="start"
            color="blue"
            style={{ top: 4, left: 4, fontSize: 12, fontWeight: 'bold' }}
          >
            {cardContent}
          </Badge.Ribbon>
        ) : (
          cardContent
        )}
      </Col>
    );
  };

  return (
    <Card
      className="offer-card"
      title="AVAILABLE OFFERS"
      // bordered={false}
      style={{
        borderRadius: 24,
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.05)',
        marginBottom: 24,
      }}
    >
      <Tabs defaultActiveKey="1" tabPosition="top" style={{ marginBottom: 24 }}>
        <TabPane tab={`No Cost Emi Offers (${taggedOffers.length})`} key="1">
          <Row gutter={[16, 16]} justify="center">
            {taggedOffers.length > 0 ? (
              taggedOffers.map(renderCard)
            ) : (
              <Text>No Tagged Offers Available</Text>
            )}
          </Row>
        </TabPane>

        <TabPane tab={`Bank & Cards Offers (${untaggedOffers.length})`} key="2">
          <Row gutter={[16, 16]} justify="center">
            {untaggedOffers.length > 0 ? (
              untaggedOffers.map(renderCard)
            ) : (
              <Text>No Untagged Offers Available</Text>
            )}
          </Row>
        </TabPane>
      </Tabs>

      <div style={{ textAlign: 'center' }}>
        <Button
          type="primary"
          onClick={() => setIsExpanded(true)}
          disabled={isExpanded}
          icon={<TagOutlined />}
          style={{
            backgroundColor: '#1890ff',
            borderColor: '#1890ff',
            boxShadow: '0 4px 8px rgba(24, 144, 255, 0.2)',
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 6px 12px rgba(24, 144, 255, 0.3)')}
          onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 4px 8px rgba(24, 144, 255, 0.2)')}
        >
          Show All Offers and Discounts
        </Button>
      </div>
    </Card>
  );
};

export default CardList;
